import { render, staticRenderFns } from "./PosterInPractise.vue?vue&type=template&id=eeb03f3e&"
import script from "./PosterInPractise.vue?vue&type=script&lang=ts&"
export * from "./PosterInPractise.vue?vue&type=script&lang=ts&"
import style0 from "./PosterInPractise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports